import { defineComponent as H, inject as g, computed as a, provide as N, watchEffect as L, createElementBlock as I, openBlock as p, normalizeStyle as A, normalizeClass as d, unref as f, createElementVNode as y, renderSlot as w, createBlock as k, withCtx as n, createVNode as i } from "vue";
import "lodash-es/cloneDeep";
import { M as E } from "./Module.keys-CEsrW2f0.js";
import "lodash-es/get";
import "lodash-es/uniqueId";
import { D as S } from "./DataView.keys-aSOnA4AD.js";
import D from "./EmptyState.js";
import O from "./Loading.js";
import x from "./TableCell.js";
import _ from "./TableRow.js";
import { T as V } from "./Table.keys-LHQf6FEH.js";
import { S as J } from "./misc-CHQs-G03.js";
var $ = /* @__PURE__ */ ((t) => (t.Scroll = "scroll", t.Stack = "stack", t))($ || {}), z = /* @__PURE__ */ ((t) => (t.None = "none", t.Rounded = "rounded", t.RoundedBottom = "rounded-bottom", t))(z || {});
const M = { class: "tw-relative tw-min-w-full tw-max-w-initial tw-border-separate" }, Z = /* @__PURE__ */ H({
  __name: "Table",
  props: {
    density: { default: void 0 },
    emptyStateText: { default: "" },
    hasActions: { type: Boolean, default: !1 },
    hasCustomExpandToggle: { type: Boolean, default: !1 },
    isEmpty: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    isExpandable: { type: Boolean, default: !1 },
    isSelectable: { type: Boolean, default: !1 },
    layout: { default: "scroll" },
    radius: { default: "rounded" },
    stickyHeader: { default: void 0 }
  },
  setup(t) {
    const e = t, {
      density: T,
      variant: u,
      isEmpty: s,
      isLoading: r,
      isSelectable: b
    } = g(S.key, S.defaults), { variant: c } = g(E.key, E.defaults), v = a(() => (c == null ? void 0 : c.value) === "table" || u.value === "table" ? "rounded-bottom" : e.radius), o = a(() => e.stickyHeader ? "scroll" : e.layout), B = a(() => o.value === "scroll" && u.value === "table"), h = a(() => {
      var l, m;
      return !!((l = e.stickyHeader) != null && l.maxHeight && ((m = e.stickyHeader) == null ? void 0 : m.listLength) > 3);
    }), C = a(() => {
      var l;
      return {
        maxHeight: h.value ? (l = e.stickyHeader) == null ? void 0 : l.maxHeight : ""
      };
    });
    return N(V.key, {
      density: a(() => e.density || T.value || J.Comfortable),
      hasCustomExpandToggle: a(() => e.hasCustomExpandToggle),
      hasActions: a(() => e.hasActions),
      isExpandable: a(() => e.isExpandable),
      isSelectable: a(
        () => e.isSelectable && !e.isLoading && !(r != null && r.value) && !e.isEmpty && !(s != null && s.value)
      ),
      layout: o
    }), L(() => {
      b && (b.value = e.isSelectable);
    }), (l, m) => (p(), I("div", {
      class: d(["stash-table tw-relative", [
        { "tw-rounded": v.value === "rounded" },
        { "tw-rounded-b": v.value === "rounded-bottom" },
        { "tw-border-t tw-border-ice-200": f(u) === "table" },
        { "tw-overflow-auto": o.value === "scroll" },
        { "tw-shadow": B.value },
        {
          "tw-overflow-visble lg:tw-overflow-auto lg:tw-shadow": o.value === "stack"
        },
        { "tw-min-h-[300px]": h.value && !e.isLoading }
        // prevent the table from collapsing on small screen heights when the max-height is dynamic
      ]]),
      "data-test": "stash-table",
      style: A(C.value)
    }, [
      y("table", M, [
        y("thead", {
          class: d(["tw-border-b tw-border-ice-200", {
            "tw-hidden lg:tw-table-header-group": o.value === "stack"
          }])
        }, [
          w(l.$slots, "head")
        ], 2),
        y("tbody", null, [
          e.isLoading || f(r) ? (p(), k(_, { key: 0 }, {
            default: n(() => [
              i(x, {
                colspan: "100%",
                class: d({ "tw-col-span-12": o.value === "stack" })
              }, {
                default: n(() => [
                  i(O)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })) : e.isEmpty || f(s) ? (p(), k(_, { key: 1 }, {
            default: n(() => [
              i(x, {
                colspan: "100%",
                class: d({ "tw-col-span-12": o.value === "stack" })
              }, {
                default: n(() => [
                  w(l.$slots, "empty", {}, () => [
                    i(D, {
                      class: "tw-w-full tw-bg-white",
                      text: e.emptyStateText
                    }, null, 8, ["text"])
                  ])
                ]),
                _: 3
              }, 8, ["class"])
            ]),
            _: 3
          })) : w(l.$slots, "body", { key: 2 })
        ])
      ])
    ], 6));
  }
});
export {
  $ as Layout,
  V as TABLE_INJECTION,
  z as TableRadius,
  Z as default
};
//# sourceMappingURL=Table.js.map
